/* =============================================================
   DUMONDE DESCRIPTION TAB
   - Înlocuiește primul tab "Detalii produs" cu un card propriu
     care arată un preview din descriere și se poate expanda inline
   - Ascunde tab-ul original ca să nu se dubleze
   ============================================================= */
(function () {
  'use strict';

  var MAX_CHARS = 280;
  var TITLE = 'Detalii produs';
  var BTN_MORE = 'Vezi mai multe';
  var BTN_LESS = 'Vezi mai puțin';

  function init() {
    if (document.querySelector('.dm-desc-tab')) return; // idempotent

    // Găsim primul disclosure (tab Detalii produs)
    var firstDisclosure = document.querySelector(
      '.product-details details-disclosure:first-of-type, ' +
      '.product-details__block details-disclosure:first-of-type'
    );
    if (!firstDisclosure) return;

    var panel = firstDisclosure.querySelector('.disclosure__panel');
    if (!panel) return;

    // Extragem HTML-ul descrierii — preferă .disclosure__content, fallback panel
    var contentEl = panel.querySelector('.disclosure__content') || panel;
    var fullHTML = contentEl.innerHTML.trim();
    if (!fullHTML) return;

    // Text simplu pentru preview (fără HTML)
    var rawText = contentEl.textContent.replace(/\s+/g, ' ').trim();
    if (rawText.length < 50) return;

    var previewText = rawText.length > MAX_CHARS
      ? rawText.substring(0, MAX_CHARS).replace(/\s+\S*$/, '') + '...'
      : rawText;

    var needsExpand = rawText.length > MAX_CHARS;

    // Construim cardul nostru
    var card = document.createElement('div');
    card.className = 'dm-desc-tab';
    card.innerHTML =
      '<div class="dm-desc-tab__head">' +
        '<h2 class="dm-desc-tab__title">' + TITLE + '</h2>' +
      '</div>' +
      '<div class="dm-desc-tab__body">' +
        '<div class="dm-desc-tab__preview">' + previewText + '</div>' +
        '<div class="dm-desc-tab__full" hidden>' + fullHTML + '</div>' +
        (needsExpand
          ? '<button type="button" class="dm-desc-tab__btn">+ ' + BTN_MORE + '</button>'
          : ''
        ) +
      '</div>';

    // Inserăm cardul ÎNAINTE de primul disclosure și ascundem originalul
    firstDisclosure.parentNode.insertBefore(card, firstDisclosure);
    firstDisclosure.style.display = 'none';

    // Toggle expand/collapse
    var btn = card.querySelector('.dm-desc-tab__btn');
    if (btn) {
      btn.addEventListener('click', function () {
        var preview = card.querySelector('.dm-desc-tab__preview');
        var full = card.querySelector('.dm-desc-tab__full');
        var isExpanded = full.hasAttribute('hidden') ? false : true;
        if (isExpanded) {
          // Collapse
          full.setAttribute('hidden', '');
          preview.removeAttribute('hidden');
          btn.textContent = '+ ' + BTN_MORE;
        } else {
          // Expand
          full.removeAttribute('hidden');
          preview.setAttribute('hidden', '');
          btn.textContent = '− ' + BTN_LESS;
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
